import KunLoading86 from './src/index'

KunLoading86.install = function (Vue) {
	Vue.component(KunLoading86.name, KunLoading86);
}

export default KunLoading86;
